// styles
import {
    HeaderBtnContainer,
    IconContainer
} from './HeaderBtn.styles.js';

export default function HeaderBtn({ val, children}) {
  return (
    <HeaderBtnContainer>
        {val != null && <h5>{val}</h5>}
        <IconContainer>
            {children}
        </IconContainer>
    </HeaderBtnContainer>
  )
}